var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomInIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.002,
    viewBox: "0 0 20 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_306",
    "data-name": "Subtraction 306",
    d: "M14818.637,17929.5a.879.879,0,0,1-.609-.254l-3.877-3.891-.176-.18-.2.16a8.892,8.892,0,1,1,1.564-1.564l-.16.2,4.061,4.053a.861.861,0,0,1,.264.615.9.9,0,0,1-.865.863Zm-10.285-18.289a7.142,7.142,0,1,0,7.141,7.139A7.145,7.145,0,0,0,14808.352,17911.213Zm0,10.281a.857.857,0,0,1-.857-.855v-1.428h-1.424a.856.856,0,1,1,0-1.713h1.424v-1.434a.858.858,0,0,1,1.717,0v1.434h1.428a.856.856,0,0,1,0,1.713h-1.428v1.428A.86.86,0,0,1,14808.352,17921.494Z",
    transform: "translate(-14799.502 -17909.5)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInIconDark);
export default __webpack_public_path__ + "static/media/zoom-in-icon-dark.6300e54b012137f0d9d78e0dfb2a0f19.svg";
export { ForwardRef as ReactComponent };